export enum NotificationType {
  ALERT = 'ALERT',
  INFO = 'INFO',
  ACTIONABLE = 'ACTIONABLE'
}
